// removed by extract-text-webpack-plugin
module.exports = {"modalClass":"styles__modalClass___1N3r5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModernEmailModal/styles.css
// module id = 2584
// module chunks = 0